import { React, useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/TelaInicial";
import Tabela from "../pages/Tabela";
import Componentes from "../pages/Componentes";
import Cores from "../pages/Cores";
import Icones from "../pages/Icones";
import Formularios from "../pages/Formulario";
import Login from "../pages/Login";

function Root({
  HandledarkMode,
  isDarkMode,
  decreaseFontSize,
  increaseFontSize,
}) {
  const [logged, setLogged] = useState(false);
  const [windowSize, setWindowSize] = useState(getWindowsSize());

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowsSize());
    }

    window.addEventListener("resize", handleWindowResize);
  }, [windowSize]);

  function getWindowsSize() {
    return window.screen.width;
  }

  if (!logged) {
    const auth = localStorage.getItem("logged");
    if (auth != null) {
      setLogged(auth);
    }
  }

  function setNewStatusLogged() {
    setLogged(!logged);
    localStorage.setItem("logged", logged);
  }

  function logOut() {
    setLogged(false);
    localStorage.removeItem("logged");
  }

  return (
    <BrowserRouter>
      {logged ? (
        <Routes>
          <Route
            path="/"
            element={
              <Home
                increaseFontSize={increaseFontSize}
                decreaseFontSize={decreaseFontSize}
                HandledarkMode={HandledarkMode}
                isDarkMode={isDarkMode}
                logOut={logOut}
              />
            }
          />
          <Route
            path="/tabela"
            element={
              <Tabela
                increaseFontSize={increaseFontSize}
                decreaseFontSize={decreaseFontSize}
                HandledarkMode={HandledarkMode}
                isDarkMode={isDarkMode}
                logOut={logOut}
              />
            }
          />
          <Route
            path="/cards"
            element={
              <Componentes
                increaseFontSize={increaseFontSize}
                decreaseFontSize={decreaseFontSize}
                HandledarkMode={HandledarkMode}
                isDarkMode={isDarkMode}
                logOut={logOut}
              />
            }
          />
          <Route
            path="/paletacores"
            element={
              <Cores
                increaseFontSize={increaseFontSize}
                decreaseFontSize={decreaseFontSize}
                HandledarkMode={HandledarkMode}
                isDarkMode={isDarkMode}
                logOut={logOut}
              />
            }
          />
          <Route
            path="/botoes"
            element={
              <Icones
                increaseFontSize={increaseFontSize}
                decreaseFontSize={decreaseFontSize}
                HandledarkMode={HandledarkMode}
                isDarkMode={isDarkMode}
                logOut={logOut}
              />
            }
          />
          <Route
            path="/formularios"
            element={
              <Formularios
                increaseFontSize={increaseFontSize}
                decreaseFontSize={decreaseFontSize}
                HandledarkMode={HandledarkMode}
                isDarkMode={isDarkMode}
                logOut={logOut}
              />
            }
          />
        </Routes>
      ) : (
        <Routes>
          <Route
            path="*"
            element={
              <Login
                setLogged={setNewStatusLogged}
                increaseFontSize={increaseFontSize}
                decreaseFontSize={decreaseFontSize}
                HandledarkMode={HandledarkMode}
                isDarkMode={isDarkMode}
              />
            }
          />
        </Routes>
      )}
      <Routes></Routes>
    </BrowserRouter>
  );
}

export default Root;
